import React from 'react'

import { Form, Col } from '_zari/core'

const CuentaContableFormGroup = ({ texto, value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text={texto} htmlFor='input-cuenta' md={4} alignRightAt='md' />
      <Col>
        <Form.InputText value={value} onChange={onChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
